<div style="display: flex; align-items: center; position: relative">
    <ng-content select="ai-label"></ng-content>
    <ng-content select="ai-icon"></ng-content>

    <div style="position: relative; width: 100%">
        <input
            #realInput
            class="ai-text-input"
            [type]="isPasswordVisible() ? 'text' : 'password'"
            [formControl]="ngControl.control"
            [placeholder]="isMasked() ? '' : placeholder()"
            (focus)="focused.set(true)"
            (blur)="focused.set(false)"
            style="padding-right: 2rem"
        />

        <!--
            Máscara: input decoy real (mascaramento nativo do navegador) sobreposto
            ao campo real quando vazio+sem foco. Clicar nele transfere o foco para
            o campo real.
        -->
        @if (isMasked()) {
            <input
                class="ai-text-input ai-password-decoy"
                type="password"
                [value]="maskValue"
                readonly
                tabindex="-1"
                (mousedown)="activateInput($event)"
                style="padding-right: 2rem"
            />
        }

        <ai-icon
            [fontIcon]="
                isPasswordVisible()
                    ? 'fa-solid fa-eye'
                    : 'fa-solid fa-eye-slash'
            "
            (click)="togglePasswordVisibility()"
            [style]="{
                color: '#555555',
                position: 'absolute',
                right: '0.5rem',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                zIndex: '1',
            }"
        />
    </div>
    <ng-content select="ai-message"></ng-content>
</div>
